import React from 'react';

const Vue_Animations = () => {
  return (
    <div>
      <h1>Vue_Animations Component</h1>
      <p>This is the Vue_Animations tutorial page.</p>
    </div>
  );
}

export default Vue_Animations;
